import { React } from "react";
// import { React, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthContext } from "./hooks/useContext/useAuthContext";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Checkout from "./pages/Checkout";
// import Signup from "./pages/Signup";
import MenuItemsPage from "./pages/MenuItemsPage";
import AllOrders from "./pages/AllOrders";
import Home from "./pages/Home";
import VerificationPage from "./pages/Verification";
import PasswordRecovery from "./pages/PasswordRecovery";
import ResetPassword from "./pages/ResetPassword";
import ResetEmail from "./pages/ResetEmail";
import Location from "./pages/Location";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Account from "./pages/Account";
import socket from './socket';
import Order from "./pages/Order";
import About from "./pages/About";
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme';
import Complete from "./pages/Complete";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Cart from "./pages/Cart";

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`, {
  locale: 'pl',
});


function App() {
  const { user } = useAuthContext();

  // useEffect(() => {
  //   function handleConnect() {
  //     // socket.connected = true;
  //     console.log('Connected to socket');
  //     // setSocketConnected(true);
  //   }

  //   function handleDisconnect() {
  //     // socket.connected = false;
  //     console.log('Disconnected from socket');
  //     // setSocketConnected(false);
  //   }

  //   socket.on('connect', handleConnect);
  //   socket.on('disconnect', handleDisconnect);

  //   return () => {
  //     socket.off('connect', handleConnect);
  //     socket.off('disconnect', handleDisconnect);
  //   };
  // }, []);


  return (
    <div className="sticky-footer">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={user ? <Dashboard socket={socket} /> : <Navigate to="/login" />} />
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" />} />
          <Route path="/checkout" element={ <Elements stripe={stripePromise}><Checkout /></Elements>} />
          {/* <Route path="/signup" element={!user ? <Signup /> : <Navigate to="/dashboard" />} /> */}
          <Route path="/menu_items" element={user ? <MenuItemsPage /> : <Order />} />
          <Route path="/all_orders" element={user ? <AllOrders socket={socket} /> : <Login />} />
          <Route path="/complete" element={<Elements stripe={stripePromise}><Complete /></Elements>} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/password_recovery" element={<PasswordRecovery />} />
          <Route path="/resetpassword/:resetPasswordToken" element={<ResetPassword />} />
          <Route path="/resetemail/:resetEmailToken" element={<ResetEmail />} />
          <Route path="/confirmation/:emailToken" element={<VerificationPage />} />
          <Route path="/confirmation" element={<VerificationPage />} />
          <Route path="/location" element={<Location />} />
          <Route path="/terms_and_conditions" element={<TermsAndConditions />} />
          <Route path="/privacy_policy" element={<PrivacyPolicy />} />
          <Route path='/account' element={user ? <Account /> : <Login />} />
          <Route path='/order' element={<Order />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ThemeProvider>
    </div>
  );
}

export default App;